import { render } from "./PlusIcon.vue?vue&type=template&id=605680e9&scoped=true"
import script from "./PlusIcon.vue?vue&type=script&lang=js"
export * from "./PlusIcon.vue?vue&type=script&lang=js"

import "./PlusIcon.vue?vue&type=style&index=0&id=605680e9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605680e9"]])

export default __exports__